<template>
  <div class="ml-1 my-2 analytics-report-link">
    <i class="far fa-list-alt mr-2"></i> <a :href="href" class="router-link-newtab" target="_blank"><slot /> <i class="far fa-chevron-right ml-1"></i> </a>
  </div>
</template>

<style lang="scss" scoped>
.analytics-report-link {
  font-weight: 600;
  font-size: 1.0em;
}
.analytics-report-link > a {
  color: $general-highlight-color;
}
</style>

<script>
export default {
  name: 'AnalyticsReportLink',
  props: {
    href: String
  }
}
</script>